import './index.scss';
import { Header } from 'src/component/Layout';
import { AppLabel, AppSpan, AppText, FlexColumn, FlexRow } from 'src/style';
import { Studentillustrator } from 'src/assets/icon';
import { HomeScreenProps } from '../types';

export const StudentHome = ({ user }: HomeScreenProps) => {
    return (
        <div className='student-home'>
            <Header user={user}>
                <FlexRow className='header-children' justifyContent='space-between'>

                    <FlexRow className='welcome' width='45' sizeUnit='%' justifyContent='left'>
                        <AppText textSize='2' fontWeight='500'>
                            Hello
                        </AppText>
                        <AppSpan
                            leftMargin='1'
                            textSize='2.6'
                            fontWeight='700'
                            color='#FFF5E5'
                        >
                            {user?.profile?.firstName ?? 'Student'}
                        </AppSpan>
                    </FlexRow>
                    <FlexColumn className='flex-class-name'>
                        <AppLabel
                            textSize='1.6'
                            color='#fff'
                            bottomMargin='0'
                            fontWeight='400'
                        >
                            Class
                        </AppLabel>
                        <AppText
                            textSize='2'
                            fontWeight='600'
                            color='#FFF5E5'
                            className='disc-text'
                        >
                            {user?.profile?.memberClass}
                        </AppText>
                    </FlexColumn>
                </FlexRow>
            </Header>
            <FlexColumn className='content-wrapper' justifyContent='space-between'>
                <FlexRow topMargin='4' className="illustrator-container" justifyContent='center' alignItems='center'>
                    <Studentillustrator />
                </FlexRow>

                <FlexColumn className='caption-constainer'>
                    <AppText align='center' className='caption-text'>
                        “A person who seeks knowledge has the ability to achieve<br />
                        anything that he or she wishes for.”
                    </AppText>
                </FlexColumn>
            </FlexColumn>
        </div>
    )
}
